import {useMemo} from 'react';
import {
    useGetAdminUsersListQuery,
    useGetUserStatusesChunkedQuery,
    UserListItem,
    usersApi,
    UsersQueryParams,
} from '../store/features/Users/userService';
import {mergeStatuses} from '../store/features/Team/statusesLongPoll';
import {useStatusesLongPoll} from './useStatusesLongPoll';

export const useUsersWithStatuses = (usersQuery: UsersQueryParams | void) => {
    const {data: usersResult, isLoading} = useGetAdminUsersListQuery(usersQuery);

    const userIds = useMemo(
        () => (usersResult?.users ?? []).map((user) => user.userId),
        [usersResult],
    );

    const {data: statuses} = useGetUserStatusesChunkedQuery(userIds, {skip: userIds.length === 0});
    useStatusesLongPoll({
        users: userIds,
        update: (incoming) => usersApi.util.updateQueryData('getUserStatusesChunked', userIds, mergeStatuses(incoming)),
        skip: userIds.length === 0,
    });

    const data = useMemo(() => {
        if (!usersResult) {
            return undefined;
        }
        const statusByUserId = new Map((statuses ?? []).map((status) => [status.userId, status]));
        return {
            users: usersResult.users.map((user) => ({
                ...user,
                ...(statusByUserId.get(user.userId) ?? {}),
            })) as unknown as UserListItem[],
            totalCount: usersResult.totalCount,
        };
    }, [usersResult, statuses]);

    return {data, isLoading};
};
